// El control de ORDEN de una fila (F2-6b A). Lo comparten la ficha del proceso
// y la lista de etapas porque es el mismo gesto en las dos, y dos copias del
// mismo par de flechas se separan a la primera corrección.
//
// Eran dos glifos de texto ("↑" / "↓") dentro de un botón fantasma: al lado de
// "Quitar" y del menú se leían como adorno, y Juan no supo para qué servían.
// Ahora son IconButton secundarios (borde propio, incluso deshabilitados: un
// control apagado sigue teniendo que verse como un control) bajo una etiqueta
// que DICE qué son, en vez de esperar a que se adivine.

import { IconButton, Tooltip } from '../../design-system/index.js'

/** La etiqueta visible del par. Sin ella el par sigue siendo un jeroglífico:
 *  el tooltip sólo aparece cuando ya sospechaste que se podía apuntar ahí. */
const ORDER_CAPTION = 'Orden'

function ArrowUpIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} aria-hidden>
      <path d="M12 19V5M6 11l6-6 6 6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

function ArrowDownIcon(): JSX.Element {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} aria-hidden>
      <path d="M12 5v14M18 13l-6 6-6-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export interface ReorderControlProps {
  /** El nombre de la fila. Las etiquetas accesibles son `Subir ${label}` /
   *  `Bajar ${label}`: nombran QUÉ se mueve, no sólo hacia dónde. */
  label: string
  /** La primera fila no sube y la última no baja: el extremo de la lista no es
   *  un error que avisar, es un movimiento que no existe. */
  upDisabled: boolean
  downDisabled: boolean
  onMoveUp: () => void
  onMoveDown: () => void
}

export function ReorderControl({
  label,
  upDisabled,
  downDisabled,
  onMoveUp,
  onMoveDown,
}: ReorderControlProps): JSX.Element {
  return (
    <div className="flex flex-none flex-col items-center gap-1">
      <span className="text-[10px] font-semibold uppercase tracking-[0.06em] text-text-3">
        {ORDER_CAPTION}
      </span>
      <div className="flex gap-1">
        <Tooltip label="Subir">
          <IconButton
            variant="secondary"
            size="md"
            icon={<ArrowUpIcon />}
            aria-label={`Subir ${label}`}
            disabled={upDisabled}
            onClick={onMoveUp}
          />
        </Tooltip>
        <Tooltip label="Bajar">
          <IconButton
            variant="secondary"
            size="md"
            icon={<ArrowDownIcon />}
            aria-label={`Bajar ${label}`}
            disabled={downDisabled}
            onClick={onMoveDown}
          />
        </Tooltip>
      </div>
    </div>
  )
}
